// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bkWDM","largestCol":"styles_largestCol__luq12","smallestCol":"styles_smallestCol__1Iiud"};